@if (isOpen) {
<div class="fixed inset-0 z-modal-top flex items-center justify-center p-4 bg-black/50">
  <div class="bg-white dark:bg-gray-900 rounded-xl shadow-xl w-full max-w-md">

    <!-- Header -->
    <div class="flex items-center justify-between p-5 border-b border-gray-200 dark:border-gray-700">
      <h3 class="text-lg font-semibold text-gray-800 dark:text-white">Cerrar Lead</h3>
      <button type="button" (click)="cancelar()"
        class="rounded-lg p-1.5 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
        <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="p-5 space-y-4">
      <p class="text-sm text-gray-600 dark:text-gray-400">
        Cerrando: <span class="font-medium text-gray-800 dark:text-white">{{ lead?.name }}</span>
      </p>

      <!-- Razón -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Razón de cierre <span class="text-error-500">*</span>
        </label>
        <select
          [ngModel]="reasonId"
          (ngModelChange)="onReasonChange($event)"
          name="reasonId"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800">
          <option [ngValue]="undefined">Seleccionar razón...</option>
          @for (reason of disqualificationReasons; track reason.id) {
          <option [ngValue]="reason.id">{{ reason.name }}</option>
          }
        </select>
      </div>

      <!-- Descripción -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Descripción (opcional)
        </label>
        <textarea
          [(ngModel)]="notes"
          rows="3"
          placeholder="Descripción del motivo de cierre..."
          class="dark:bg-dark-900 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800">
        </textarea>
      </div>

      <!-- Fecha de reintento -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Fecha de reintento (opcional)
        </label>
        <input
          type="date"
          [(ngModel)]="retryDate"
          [min]="todayDate"
          (click)="$any($event.target).showPicker?.()"
          (focus)="$any($event.target).showPicker?.()"
          class="dark:bg-dark-900 dark:[color-scheme:dark] h-11 w-full cursor-pointer rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800"
          [class.border-error-500]="retryDateIsPast">
        @if (retryDateIsPast) {
          <p class="mt-1.5 text-xs text-error-500">La fecha de reintento no puede ser anterior a hoy.</p>
        }
      </div>

      <!-- Reintento programado -->
      <div class="flex items-start gap-3">
        <input
          type="checkbox"
          [(ngModel)]="isRetryScheduled"
          id="closeLeadRetryScheduled"
          class="mt-0.5 h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500/10 dark:border-gray-600 dark:bg-gray-800">
        <label for="closeLeadRetryScheduled" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          Reintento programado
        </label>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-end gap-3 p-5 border-t border-gray-200 dark:border-gray-700">
      <button type="button"
        (click)="cancelar()"
        class="px-4 py-2 text-sm rounded-lg font-medium border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
        Cancelar
      </button>
      <button type="button"
        [disabled]="!reasonId || saving || retryDateIsPast"
        (click)="confirmar()"
        class="px-4 py-2 text-sm rounded-lg font-medium bg-error-500 text-white hover:bg-error-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
        {{ saving ? 'Guardando...' : 'Confirmar cierre' }}
      </button>
    </div>

  </div>
</div>
}
